import React from 'react';
import PropTypes from 'prop-types';
import Icon from '@material-ui/core/Icon';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';

const propTypes = {
  icon: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
  classes: PropTypes.shape({
    root: PropTypes.string,
  }),
};

const defaultProps = {
  classes: { root: '' },
};

const useStyles = makeStyles(theme => ({
  root: {
    margin: 0,
    verticalAlign: 'middle',
  },
  success: {
    color: theme.palette.success.main,
  },
  error: {
    color: theme.palette.error.main,
  },
  primary: {
    color: theme.palette.primary.contrastText,
  },
  secondary: {
    color: theme.palette.secondary.main,
  },
  buttonIco: {
    color: theme.palette.primary.contrastText,
  },
}));

const DefaultIcons = (props) => {
  const {
    icon, color, classes, ...others
  } = props;

  const cls = useStyles();

  const iconProps = {
    classes: {
      root: clsx(
        cls.root,
        classes.root,
        { [cls[color]]: color },
      ),
    },
    color: 'primary',
    ...others,
  };

  return (
    <Icon {...iconProps}>
      { icon }
    </Icon>
  );
};

DefaultIcons.propTypes = propTypes;
DefaultIcons.defaultProps = defaultProps;

export default DefaultIcons;
